<template>
  <div>
    <Modal @closeModal="$emit('close-triggered')">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <span class="font-weight-bold">Invite School</span>
      </div>

      <!-- MODAL BODY -->
      <div slot="modal-body">
        <div
          v-if="showAlert"
          class="alert"
          :class="'alert-' + messageType"
          style="transition: ease 0.5s"
        >
          {{ message }}
        </div>

        <div class="info-text color_text">
          Invite your school to access your school classes. You will be
          assigned to a class as soon as your school joins.
        </div>

        <form action @submit.prevent="submitForm">
          <!-- SCHOOL NAME -->
          <div class="modal-body-row row">
            <div class="col-12">
              <label
                for="schoolName"
                class="control-label text-uppercase color_grey_dark"
                >School Name</label
              >
              <input
                type="text"
                v-model="form.receiver_name"
                class="form-control"
                onKeyPress="if(this.value.length >= 60) return false;"
                id="schoolName"
                placeholder="Enter the name of your school"
              />
            </div>
          </div>

          <!-- CONTACT EMAIL ADDRESS -->
          <div class="modal-body-row row">
            <div class="col-12">
              <label
                for="contactEmail"
                class="control-label text-uppercase color_grey_dark"
                >Contact Email Address</label
              >
              <input
                type="email"
                v-model="form.receiver_email"
                class="form-control"
                id="contactEmail"
                placeholder="Enter the name of your school"
              />
            </div>
          </div>

          <!-- CONTACT PHONE NUMBER -->
          <div class="modal-body-row row">
            <div class="col-12">
              <label
                for="contactPhone"
                class="control-label text-uppercase color_grey_dark"
                >Contact Phone Number</label
              >
              <input
                type="number"
                v-model="form.receiver_phone"
                onKeyPress="if(this.value.length >= 11) return false;"
                class="form-control"
                id="contactPhone"
                placeholder="Enter the phone number of your school"
              />
            </div>
          </div>

          <!-- SEND INVITATION-->
          <div
            class="modal-body-row row d-flex justify-content-center align-items-center nowrap mb-2"
          >
            <button
              @click="$emit('close-triggered')"
              class="btn btn-md black-ic z-depth-0 mr-3"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-md btn-accent ml-3"
              :disabled="isDisabled"
            >
              Invite School
            </button>
          </div>
        </form>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/globalComps/Modal";

export default {
  name: "InviteSchoolModal",

  components: { Modal },

  data() {
    return {
      form: {
        receiver_name: "",
        receiver_email: "",
        receiver_phone: "",
      },
      message: "",
      messageType: "",
      showAlert: false,
    };
  },

  computed: {
    isDisabled() {
      return (
        this.form.school_name == "" ||
        this.form.contact_email == "" ||
        this.form.contact_phone == ""
      );
    },
  },

  methods: {
    submitForm() {
      this.$store.dispatch("parentInviteSchool", this.form).then((res) => {
        if (res.code == 200) {
          this.showMsg("success", "Invite has been successfully sent");
          this.$emit("invite-school");
        } else {
          this.showMsg("danger", Object.values(res.data)[0][0]);
        }
      });
    },

    showMsg(alertType, alertMessage) {
      this.messageType = alertType;
      this.message = alertMessage;
      this.showAlert = true;

      setTimeout(() => {
        this.showAlert = false;
      }, 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
.info-text {
  font-size: 14.5px;
  line-height: 165%;
  margin-bottom: 30px;

  @include breakpoint_max(sm) {
    margin-bottom: 20px;
    font-size: 12.4px;
  }
}
</style>
